import { media } from '@simplywallst/ui-core';
import styled from 'styled-components';

export const TextWrapper = styled.div`
  color: ${({ theme }) => theme.color.textSolid};
  ${({ theme }) => theme.typography.small}
  ${media.smDown`
    ${({ theme }) => theme.typography.xSmall}
  `}
`;
